import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StepIconProps } from '@mui/material';
import useIsMobile from '../hooks/useIsMobile';
import { designTokens } from '../design-system/tokens';

// Custom step icon component
const CustomStepIcon = (props: StepIconProps) => {
  const { active, completed } = props;

  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: active || completed ? designTokens.colors.brand.secondary[500] : designTokens.colors.neutral[0],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: active || completed ? `2px solid ${designTokens.colors.brand.secondary[500]}` : `2px solid ${designTokens.colors.neutral[300]}`,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: active || completed ? designTokens.colors.neutral[0] : designTokens.colors.neutral[300],
        }}
      />
    </Box>
  );
};

interface CustomStepperProps {
  steps: string[];
  currentStep: number;
}

const CustomStepper = ({ steps, currentStep }: CustomStepperProps) => {
  const isMobile = useIsMobile();
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper
        activeStep={currentStep}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        alternativeLabel={!isMobile}
        sx={{
          '& .MuiStepConnector-root': {
            '& .MuiStepConnector-line': {
              borderColor: designTokens.colors.neutral[300],
              borderWidth: '2px',
            },
          },
          '& .MuiStepConnector-completed .MuiStepConnector-line': {
            borderColor: designTokens.colors.brand.secondary[500],
          },
          '& .MuiStepLabel-label': {
            fontSize: '16px',
            fontWeight: '500',
          },
          ...(isMobile && {
            '& .MuiStepConnector-root .MuiStepConnector-line': {
              minHeight: '24px',
              borderLeftWidth: '3px',
              borderTopWidth: '0px',
              borderRightWidth: '0px',
              borderBottomWidth: '0px',
            },
            '& .MuiStepConnector-completed .MuiStepConnector-line': {
              borderColor: designTokens.colors.brand.secondary[500],
            },
          }),
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomStepper;
